import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
    static targets = ["maker", "brand"]
    connect() {
        if (this.makerTarget.value) {
            this.changeMaker()
        }
    }

    changeMaker() {
        const makerId = this.makerTarget.value

        if (!makerId) {
            this.brandTarget.innerHTML = ""
            return
        }

        fetch(`/buybye_admin/products/${makerId}/product_brands`)
            .then(res => res.json())
            .then(brands => {
                const selectedBrandId = this.brandTarget.dataset.selectedBrandId
                this.brandTarget.innerHTML = ""

                brands.forEach((brand) => {
                    const option = document.createElement("option")
                    option.value = brand.id
                    option.textContent = brand.name

                    if (String(brand.id) === selectedBrandId) {
                        option.selected = true
                    }

                    this.brandTarget.appendChild(option)
                })
            })
    }
}